<template>
  <div v-if="isLoading" class="app-loader-overlay">
    <div class="app-loader-container">
      <!-- Animated Logo/Icon -->
      <div class="loader-logo">
        <div class="logo-circle">
          <i class="mdi mdi-food-fork-drink"></i>
        </div>
      </div>
      
      <!-- Loading Text -->
      <div class="loader-text">
        <h3>Get Me Food</h3>
        <p>Getting things ready...</p>
      </div>
      
      <!-- Animated Progress Bar -->
      <div class="loader-progress">
        <div class="progress-bar">
          <div class="progress-fill"></div>
        </div>
      </div>
      
      <!-- Loading Dots -->
      <div class="loading-dots">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppLoader',
  props: {
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
.app-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #f4f6fb;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.app-loader-container {
  text-align: center;
  color: #0f172a;
  max-width: 320px;
  padding: 24px;
}

.loader-logo {
  margin-bottom: 20px;
}

.logo-circle {
  width: 64px;
  height: 64px;
  border-radius: 16px;
  background: linear-gradient(90deg, #241B5A 0%, #14132F 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: 0 8px 24px rgba(36, 27, 90, 0.28);
}

.logo-circle i {
  font-size: 28px;
  color: white;
  animation: none;
}

.loader-text h3 {
  font-size: 22px;
  font-weight: 700;
  margin: 0 0 6px 0;
  color: #0f172a;
  font-family: Inter, ui-sans-serif, sans-serif;
  text-shadow: none;
}

.loader-text p {
  font-size: 14px;
  color: #64748b;
  margin: 0 0 20px 0;
  font-family: Inter, ui-sans-serif, sans-serif;
  font-weight: 400;
  opacity: 1;
}

.loader-progress {
  margin-bottom: 16px;
}

.progress-bar {
  width: 100%;
  height: 3px;
  background: #e2e8f0;
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #241B5A, #14132F);
  border-radius: 2px;
  animation: progress 1.2s ease-in-out infinite;
  box-shadow: none;
}

.loading-dots {
  display: flex;
  justify-content: center;
  gap: 6px;
}

.loading-dots span {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #241B5A;
  animation: dots 1.4s infinite ease-in-out;
}

.loading-dots span:nth-child(1) {
  animation-delay: -0.32s;
}

.loading-dots span:nth-child(2) {
  animation-delay: -0.16s;
}

/* Animations */
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
  }
  50% {
    transform: scale(1.05);
    box-shadow: 0 0 30px rgba(255, 255, 255, 0.5);
  }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

@keyframes progress {
  0% {
    width: 0%;
  }
  50% {
    width: 70%;
  }
  100% {
    width: 100%;
  }
}

@keyframes dots {
  0%, 80%, 100% {
    transform: scale(0.8);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .app-loader-container {
    padding: 20px;
  }
  
  .logo-circle {
    width: 60px;
    height: 60px;
  }
  
  .logo-circle i {
    font-size: 28px;
  }
  
  .loader-text h3 {
    font-size: 24px;
  }
  
  .loader-text p {
    font-size: 14px;
  }
}
</style>
